import type { Router } from 'vue-router'

const KEY = 'onboardingPathStack'

interface HistoryState {
  stack: string[]
}

function read(): HistoryState {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) {
      return { stack: [] }
    }
    const parsed = JSON.parse(raw)
    const stack = Array.isArray(parsed?.stack) ? parsed.stack.filter((x: unknown) => typeof x === 'string') : []
    return { stack }
  }
  catch {
    return { stack: [] }
  }
}

function write(state: HistoryState) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ stack: state.stack.slice(-50) }))
  }
  catch {}
}

export function recordOnboardingPath(path: string) {
  const state = read()
  const stack = state.stack
  const existingIndex = stack.lastIndexOf(path)
  if (existingIndex >= 0) {
    write({ stack: stack.slice(0, existingIndex + 1) })
    return
  }
  const next = stack.slice()
  if (next.length === 0 || next[next.length - 1] !== path) {
    next.push(path)
  }
  write({ stack: next })
}

export function previousOnboardingPath(): string | null {
  const { stack } = read()
  if (stack.length < 2) {
    return null
  }
  return stack[stack.length - 2] || null
}

export function popCurrentAndGetPrevious(): string | null {
  const state = read()
  const stack = state.stack.slice()
  if (stack.length === 0) {
    return null
  }
  stack.pop()
  write({ stack })
  return stack.length > 0 ? stack[stack.length - 1] : null
}

export function clearOnboardingPath() {
  try {
    sessionStorage.removeItem(KEY)
  }
  catch {}
}

export function navigateBackInOnboarding(router: Router, fallback: string): string {
  const prev = popCurrentAndGetPrevious()
  const target = prev || fallback
  router.push(target)
  return target
}
